<template>
	<div class="about-swap">
		<TnHeading
			size="l"
			center
			type="h3"
			class="margin-bottom-2xl"
			>{{ heading }}</TnHeading
		>
		<section>
			<ul class="about-swap-card-grid">
				<AboutSwapCard
					v-for="(card, index) in cards"
					class="about-swap-card-grid-card"
					:key="`card-${index}`"
					:card="card"
				/>
			</ul>
		</section>
		<!-- SWAP Explained with video-->
		<section
			v-if="showSwapMovie"
			style="display: flex; justify-content: center; flex-direction: column; align-items: center"
		>
			<TnParagraph
				class="explained"
				size="xl"
				bold
				responsive
				>{{ movieTitle }}</TnParagraph
			>

			<TnVideo
				controls
				:src-youtube="movieUrl"
			/>
		</section>
		<!-- SWAP Accordion FAQ -->
		<section class="faq">
			<TnAccordion :multiple="false">
				<TnAccordionItem
					v-for="dropdown in dropDowns"
					:key="dropdown?.key"
					:title="dropdown?.title"
					rounded
				>
					<TnParagraph size="s">
						{{ dropdown?.description }}

						<LinkInline
							v-if="dropdown?.link"
							:to="dropdown?.link"
						>
							{{ dropdown?.linkTitle }}
						</LinkInline>
					</TnParagraph>
				</TnAccordionItem>
			</TnAccordion>
		</section>
	</div>
</template>

<script>
export default defineNuxtComponent({
	props: {
		cards: {
			type: Array,
			default: () => [],
		},
		dropDowns: {
			type: Array,
			default: () => [],
		},
		heading: {
			type: String,
			default: "",
		},
		movieTitle: {
			type: String,
			default: "",
		},
		movieUrl: {
			type: String,
			default: "",
		},
		showSwapMovie: {
			type: Boolean,
			default: false,
		},
	},
});
</script>

<style lang="scss" scoped>
.about-swap-card-grid {
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: $spacing-l;

	@include breakpoint(tablet) {
		flex-wrap: wrap;
	}

	@include breakpoint(mobile) {
		flex-wrap: wrap;
	}
}

.about-swap-card-grid-card {
	flex: 1;
	max-width: 220px;

	@include breakpoint(tablet) {
		min-width: 220px;
		max-width: 350px;
	}

	@include breakpoint(mobile) {
		width: 100%;
	}
}

.about-swap {
	max-width: 100%;
	padding-top: $spacing-xl;
}

.explained {
	text-align: center;
	margin: $spacing-xl 0;
}

.faq {
	margin-top: $spacing-xl;
}
</style>
